import React from 'react';
import PropTypes from 'prop-types';

const FlagIcon = ({ name, classes }) => (
  <span className={`icon flag-icon flag-icon-${name} ${classes}`} />
);

FlagIcon.propTypes = {
  name: PropTypes.string.isRequired,
  classes: PropTypes.string,
};

export default FlagIcon;



// WEBPACK FOOTER //
// ./library/app/components/Global/Icons/FlagIcon.js